import React from "react";
import { matchPath, useLocation } from "react-router-dom-v5";
import { useSelector } from "react-redux";
import { getCurrentUser } from "../../selectors/userSelectors";
import Footer from "../footer/Footer";
import CourseTrialCountdownContainer from "../courses/CourseTrialCountdownContainer";
import CourseUnlockContainer from "../courses/CourseUnlockContainer";
import { AppLayout } from "../../features/navigation/AppLayout";
import { LessonSidebarShell } from "../../features/navigation/LessonSidebarShell";
import { MockSidebarShell } from "../../features/navigation/MockSidebarShell";

function getSidebarForRoute(pathname) {
  const isNewMockPath = !!matchPath(pathname, {
    path: ["/mocks/new", "/mocks/custom/new", "/mocks/exam/new", "/mocks/teacher"],
  });

  if (
    matchPath(pathname, { path: "/courses/:courseId/lessons/:lessonId" })
  ) {
    return { sidebar: <LessonSidebarShell />, sidebarWidth: "320px" };
  }

  if (matchPath(pathname, { path: "/mocks/:id" }) && !isNewMockPath) {
    return { sidebar: <MockSidebarShell />, sidebarWidth: "320px" };
  }

  return {};
}

export default function Page({ title, actions, children }) {
  const { pathname } = useLocation();
  const user = useSelector((state) => getCurrentUser(state));
  const { sidebar, sidebarWidth } = getSidebarForRoute(pathname);

  if (!user) {
    return <>{children}</>;
  }

  return (
    <AppLayout
      title={title}
      actions={actions}
      sidebar={sidebar}
      sidebarWidth={sidebarWidth}
      banners={
        <>
          <CourseUnlockContainer />
          <CourseTrialCountdownContainer />
        </>
      }
      footer={<Footer />}
    >
      {children}
    </AppLayout>
  );
}
